/**
 * @copyright Copyright 2024 Epic Systems Corporation
 * @file app key download tags
 * @module Epic.AppOrchard.AppListing.ApiCollapse
 */

import { Tag } from "@chakra-ui/react";
import { ClientApplicationStatus, DownloadApprovedStatus } from "ao/data/types";
import React, { FunctionComponent, memo } from "react";

interface IProps {
	downloadApprovedStatus: DownloadApprovedStatus;
	appStatus?: ClientApplicationStatus;
	isProdOnly?: boolean;
}

export const AppKeyDownloads: FunctionComponent<IProps> = memo((props) => {
	const { downloadApprovedStatus, appStatus, isProdOnly } = props;

	let label = "";
	let color = "";

	switch (downloadApprovedStatus) {
		case DownloadApprovedStatus.Approved:
			label = isProdOnly
				? "Client ID downloaded for Production"
				: "Client ID downloaded for all environments";
			color = "green";
			break;
		case DownloadApprovedStatus.NonProdOnly:
			label = "Client ID downloaded for Non-Production";
			color = "blue";
			break;
		case DownloadApprovedStatus.Unapproved:
			label = "Pending vendor approval";
			color = "gray";
			break;
		case DownloadApprovedStatus.Declined:
			label = "Download request declined";
			color = "red";
			break;
		default:
			break;
	}

	if (appStatus === ClientApplicationStatus.Inactive) {
		label = "Inactive";
		color = "gray";
	}
	return (
		<Tag size="md" variant="showroom" colorScheme={color} textAlign="center">
			{label}
		</Tag>
	);
});
